import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'i18next'
import { Formatter } from 'Utils/Formatter'
import { getYappyPayments } from 'Utils/yappyPayments'
import './YappyPaymentInfo.css'

function getConfirmationNumber(payment) {
  return payment?.TransactionCCNumber || null
}

const STATUS_COLORS = {
  Pagado: '#16a34a',
  'Parcialmente pagado': '#ea580c',
  Pendiente: '#9ca3af',
}

function YappyPaymentInfo({
  payments,
  totalPayment,
  statusPayment,
  className,
}) {
  const yappyPayments = getYappyPayments(payments)
  const latestPayment = yappyPayments[yappyPayments.length - 1]
  const confirmationNumber = getConfirmationNumber(latestPayment)

  const formattedDate = latestPayment?.PaymentDate
    ? new Date(latestPayment.PaymentDate).toLocaleDateString('es-PA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : null

  const statusColor = STATUS_COLORS[statusPayment]
  // totalPayment puede venir vacío si la fuente (SalesDocumentInfo/QuoteHeader)
  // todavía no expone el campo agregado; el pago Yappy ya trae su propio monto.
  const amount = totalPayment ?? latestPayment?.PaymentAmount ?? 0
  const amountFormatted = `$${Formatter.Money(amount, {
    rounded: true,
    decimalPrecision: 2,
  })}`

  return (
    <div
      className={['yappy-payment-info', className].filter(Boolean).join(' ')}
      data-testid="container-yappy-payment-info">
      <p className="yappy-payment-info__title">
        {t('YAPPY_PAYMENT_INFO_T.TITLE')}
      </p>

      <p
        className="yappy-payment-info__line yappy-payment-info__line--nowrap"
        data-testid="text-payment-line">
        {`${t('YAPPY_PAYMENT_INFO_T.METHOD_NAME')}: `}
        <span data-testid="text-paid-amount">{amountFormatted}</span>
        {confirmationNumber && (
          <>
            {` - ${t('YAPPY_PAYMENT_INFO_T.CONFIRMATION_NUMBER_LABEL')}: `}
            <span data-testid="text-payment-confirmation">
              {confirmationNumber}
            </span>
          </>
        )}
      </p>

      <p className="yappy-payment-info__line">
        {formattedDate && (
          <span data-testid="text-payment-date">{formattedDate}</span>
        )}
        {statusPayment && (
          <span
            className="yappy-payment-info__status"
            style={{ color: statusColor, whiteSpace: 'nowrap' }}
            data-testid="badge-payment-status">
            {formattedDate ? '  ' : ''}&#9679;&thinsp;
            {statusPayment}
          </span>
        )}
      </p>
    </div>
  )
}

YappyPaymentInfo.propTypes = {
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      PaymentType: PropTypes.string,
      PaymentName: PropTypes.string,
      TransactionCCNumber: PropTypes.string,
      TransactionCCName: PropTypes.string,
      PaymentAmount: PropTypes.number,
      PaymentDate: PropTypes.string,
    })
  ),
  totalPayment: PropTypes.number,
  statusPayment: PropTypes.string,
  className: PropTypes.string,
}

export default YappyPaymentInfo
